export default "__VITE_ASSET__BxzFOiPB__"